export default "__VITE_ASSET__CL7ULwQv__"